import { TFunction } from "i18next";

export function getPasswordRequirements(
	password: string,
	translation: TFunction<"translation", undefined>
) {
	const hasLower = /[a-z]/.test(password);
	const hasUpper = /[A-Z]/.test(password);
	const hasDigit = /\d/.test(password);
	const hasSpecialChar = /[!@#$%^&*(),.?:{}|]/.test(password);

	const req = [
		{
			satisfied: password && password.length >= 8,
			description: translation("MinimumEightCharacter"),
		},
		{
			satisfied: hasLower && hasUpper,
			description: translation("AtLeaseOneUpperAndLower"),
		},
		{
			satisfied: hasDigit,
			description: translation("ContainsNumber"),
		},
	];
	return req;
}
